import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';
import Select from './components/Select.vue';

export const SkladOjetychVozu = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
	},
};
